import { createContext, useContext, useMemo, type ReactNode } from 'react'
import type { OrderEventDocumentRef } from '@klear/upload/order-event-documents'
import { useOrderEventDocuments } from '@klear/ui/hooks/use-order-event-documents'

export type OrderEventDocumentsValue = {
  documentsFor: (orderEventId: number | null | undefined) => OrderEventDocumentRef[]
  isFetching: boolean
}

const EMPTY: OrderEventDocumentRef[] = []

const OrderEventDocumentsContext = createContext<OrderEventDocumentsValue>({
  documentsFor: () => EMPTY,
  isFetching: false
})

export function OrderEventDocumentsProvider({
  orderEventIds,
  traderId,
  children
}: {
  orderEventIds: readonly (number | null | undefined)[]
  traderId?: number
  children: ReactNode
}) {
  const { documentsFor, isFetching } = useOrderEventDocuments(orderEventIds, traderId)
  const value = useMemo(() => ({ documentsFor, isFetching }), [documentsFor, isFetching])

  return <OrderEventDocumentsContext.Provider value={value}>{children}</OrderEventDocumentsContext.Provider>
}

export function useOrderEventDocumentsFor(orderEventId: number | null | undefined): OrderEventDocumentRef[] {
  return useContext(OrderEventDocumentsContext).documentsFor(orderEventId)
}
